import React, { useEffect, useRef, useState } from 'react';
import { getPaidLeads } from '@/API/repositories/reports';
import { useRequestsContext } from '@/common/hooks/requestHook';
import { useCommonDataContext } from '@/common/hooks/commonDataContext';
import CustomSkeleton from '@/common/components/CustomSkeleton';
import Input from '@/common/components/Input';
import {
	ChartWrapper,
	TitleSection,
	TopContentWrapper,
	Wrapper,
} from '../shared.styles';
import CustomLine from '@/common/charts/Line';
import Icon from '@/common/components/Icon';
import { useMessageQueueContext } from '@/common/hooks/useMessageQueue';
import { PRODUCT_CHART_WRAPPER_HEIGHT } from '../../constants/productStatusOptions';
import { applyChartDatasetsFilter } from '../../helpers/applyChartDatasetsFilter';
import { useProductChartFilters } from '../../hooks/useProductChartFilters';
import ProductChartFilters from '../productChartFilters/ProductChartFilters';
import ProductChartActions from '../productChartFilters/ProductChartActions';

const PaidLeads = () => {
	const [chartData, setChartData] = useState();
	const [rawData, setRawData] = useState();
	const {
		commonData: { products },
	} = useCommonDataContext();
	const timeRangeRef = useRef();

	const { makeRequest } = useRequestsContext();
	const { addMessage } = useMessageQueueContext();
	const {
		productStatus,
		setProductStatus,
		selectedProducts,
		setSelectedProducts,
		productOptions,
		handleSelectAll,
		handleUnselectAll,
	} = useProductChartFilters(products);

	const handleLoadData = async () => {
		setChartData(() => null);
		setRawData(() => null);

		const payload = {};
		payload.timeFrom = timeRangeRef.current.value;

		const response = await makeRequest(getPaidLeads.bind(null, payload));

		if (!response?.data) {
			addMessage('Something went wrong', 'error');
			return;
		}

		setRawData(() => response.data);
	};

	useEffect(() => {
		if (products[0]) {
			handleLoadData();
		}
	}, [products]);

	useEffect(() => {
		applyChartDatasetsFilter({
			rawData,
			selectedProducts,
			setChartData,
		});
	}, [rawData, selectedProducts]);

	return (
		<Wrapper width={800} height={PRODUCT_CHART_WRAPPER_HEIGHT}>
			<TitleSection>
				<TopContentWrapper>
					<Icon name='people-group' size={20} />
					Paid leads
				</TopContentWrapper>
				<TopContentWrapper>
					<Input
						showLabel={false}
						inputWidth={50}
						value={14}
						inputRef={timeRangeRef}
					/>
					<Icon
						name='arrows-rotate'
						style={{ cursor: 'pointer' }}
						onClick={() => handleLoadData()}
					/>{' '}
				</TopContentWrapper>
			</TitleSection>
			<ProductChartFilters
				productStatus={productStatus}
				setProductStatus={setProductStatus}
				productOptions={productOptions}
				selectedProducts={selectedProducts}
				setSelectedProducts={setSelectedProducts}
			/>
			<ChartWrapper>
				{chartData ? (
					<CustomLine data={chartData} />
				) : (
					<CustomSkeleton width={750} count={16} height={5} />
				)}
			</ChartWrapper>
			<ProductChartActions
				handleSelectAll={handleSelectAll}
				handleUnselectAll={handleUnselectAll}
			/>
		</Wrapper>
	);
};

export default PaidLeads;
